export enum Clef {

  TREBLE = 'treble',
  ALTO = 'alto',
  TENOR = 'tenor',
  BASS = 'bass',
  PERCUSSION = 'percussion',
  BARITONE_F = 'baritone-f',
  MEZZO_SOPRANO = 'mezzo-soprano'

}
